import { render } from "./ReceiptLoader.vue?vue&type=template&id=17520824"
import script from "./ReceiptLoader.vue?vue&type=script&lang=js"
export * from "./ReceiptLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__